import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(4)};

  height: 100%;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(2)};

  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const IconContainer = styled.span<{ $large?: boolean }>`
  font-size: 4rem;
  line-height: 62.5%;

  ${({ $large }) =>
    $large &&
    css`
      font-size: 9.2rem;
    `};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;
